import { Page } from 'Common/Page/Page'
import { PageHeader } from 'Common/Supplyvue-ui'
import { Box } from '@mui/material'
import { useSettingsContext } from 'Features/Projects/Scenarios/EditSettings/EditSettings.types'
import { useWindowSize } from 'Common/hooks/useWindowSize.hook'
import { max } from 'lodash'
import { ReplenishmentTable } from 'Features/Projects/Scenarios/EditSettings/NetworkSettings/Replenishment/Replenishment.Table'
import {
  useReplenishmentCycleTime,
  useReplenishmentSiteSkus,
} from './Replenishment.data'

export const ReplenishmentView = () => {
  const { state } = useSettingsContext()
  const { projectId, scenarioId } = state
  const { view_width, view_height } = useWindowSize()
  const { data: replenishmentSiteSkus, isLoading } = useReplenishmentSiteSkus({
    projectId,
    scenarioId,
  })

  const {
    data: replenishmentCycleTimeData,
    isLoading: isLoadingCycleTimeData,
  } = useReplenishmentCycleTime({
    projectId,
    scenarioId,
  })

  return (
    <Page>
      <Box
        display="flex"
        flex="auto"
        flexDirection="column"
        justifyContent="flex-start"
        maxWidth={view_width}
        maxHeight={max([view_height, 1500])}
      >
        <PageHeader
          title="Replenishment"
          // rightElement={<EditSettingsDataFilter />}
        />
        <ReplenishmentTable
          data={replenishmentSiteSkus ?? []}
          isLoading={isLoading || isLoadingCycleTimeData}
          replenishmentCycleTimeData={replenishmentCycleTimeData}
        />
      </Box>
    </Page>
  )
}
